<template>
  <div class="home">
    <b-navbar toggleable="lg" type="light" fixed="top">
      <b-navbar-brand href="#inicio"><img class="logo" src="../assets/logo.svg" alt="logo"></b-navbar-brand>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto"> 
          <b-nav-item href="#nosotros">Sobre nosotros</b-nav-item>
          <b-nav-item href="#servicios">Servicios</b-nav-item>
          <b-nav-item href="#derechos">Derechos</b-nav-item>
          <b-nav-item href="#gestion">Gestión</b-nav-item>
          <b-nav-item class="btn-contact" href="#contacto">Contacto</b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <div class="banner">
      <b-container id="inicio">
        <b-row>
          <b-col lg="9" align-self="center">
            <h1>Nuestro interés siempre ha sido y será que conozcas la realidad jurídica de la situación en la que te encuentres.</h1>
            <p>Aquí en Hector Terán Abogados, hemos insistido en que nuestro trabajo no es hacer un problema mas grande, sino es resolverlo, pero para ello, es de suma importancia que el cliente conozca y entienda perfectamente la realidad de la situación, por lo que nuestro mayor interés, es tener la oportunidad conocer sus hechos, retroalimentándolos en presencia de nuestros expertos, logrando así una tranquilidad emocional.</p>
            <b-button href="#contacto">Agendar cita</b-button>
          </b-col>
        </b-row>
      </b-container>
    </div>
    
    
    <b-container class="nosotros" style="position: relative;">
      <div id="nosotros" style="position: absolute; top: -100px;"></div>
      <b-row class="p1 mx-auto">
        <b-col class="text-center">
          <p>Hector Terán & Abogados consiste en una firma legal dedicada y enfocada a cuidar los derechos fundamentales de las personas que forman nuestra sociedad, poniendo a su disposición la experiencia de 49 años de litigio en diferentes materias que conforman nuestro derecho.</p>
          <p>Esta firma cree profundamente en la idea de compartir el conocimiento que se ha adquirido a lo largo de más de cuatro décadas ejerciendo la materia, para que así, el cliente conozca realmente su situación Jurídica, tomando así de nuestra mano, las decisiones que en derecho correspondan, siempre buscando como nuestro principal interés, el resolver problemáticas.</p>
        </b-col>
      </b-row>
      <b-row class="p2 mx-auto">
        <b-col class="mb-4" md="4">
          <img class="img-fluid" src="../assets/img1.png" alt="libros">
        </b-col>
        <b-col class="mb-4" md="4">
          <img class="img-fluid" src="../assets/img2.png" alt="bandera">
        </b-col>
        <b-col class="mb-4" md="4">
          <img class="img-fluid" src="../assets/img3.png" alt="mazo">
        </b-col>
      </b-row>
      <b-row class="text-center">
        <b-col>
          <h4>DESDE 1976</h4>
          <h4>Una firma preocupada por apoyar y proteger a nuestra comunidad Baja Californiana</h4>
        </b-col>
      </b-row>
    </b-container>

    <div class="servicios" style="position: relative;">
      <div id="servicios" style="position: absolute; top: -100px;"></div>
      <b-container>
        <b-row>
          <b-col class="mb-5" lg="12">
            <h3 class="mb-4">Servicios</h3>
            <p>Contamos con el compromiso específico a satisfacer todas y cada una de las necesidades legales como situaciones de consultoría que se puedan necesitar, en razón de lo anterior, esta firma ofrece servicios en las siguientes materias:</p>
          </b-col>
          <b-col lg="6">
            <p class="mb-4 bullets"><img src="../assets/arrow.svg" alt="flecha"> Amparo</p>
            <b-button v-b-toggle.collapse-2><p class="mb-4 bullets"><img src="../assets/arrow.svg" alt="flecha"> Derecho Civil <span class="more">+</span><span class="less">-</span></p></b-button>
            <b-collapse id="collapse-2">
              <b-card>Ejecución o terminación de contratos, recuperación de vivienda, prescripciones, regularización de propiedades, compra/venta.</b-card>
            </b-collapse>
            <b-button v-b-toggle.collapse-3><p class="mb-4 bullets"><img src="../assets/arrow.svg" alt="flecha"> Derecho Mercantil <span class="more">+</span><span class="less">-</span></p></b-button>
            <b-collapse id="collapse-3">
              <b-card>Cobro de pagares, cheques o cualquier título de crédito, adeudos.</b-card>
            </b-collapse>
            <b-button v-b-toggle.collapse-4><p class="mb-4 bullets"><img src="../assets/arrow.svg" alt="flecha"> Derecho Mercantil Internacional <span class="more">+</span><span class="less">-</span></p></b-button>
            <b-collapse id="collapse-4">
              <b-card>Adeudos internacionales.</b-card>
            </b-collapse>
            <b-button v-b-toggle.collapse-5><p class="mb-4 bullets"><img src="../assets/arrow.svg" alt="flecha"> Derecho Corporativo <span class="more">+</span><span class="less">-</span></p></b-button>
            <b-collapse id="collapse-5">
              <b-card>Elaboración de contratos, Compliance, Avisos de privacidad; Estructuración juridica de empresas.</b-card>
            </b-collapse>
            <b-button v-b-toggle.collapse-6><p class="mb-4 bullets"><img src="../assets/arrow.svg" alt="flecha"> Derecho Administrativo <span class="more">+</span><span class="less">-</span></p></b-button>
            <b-collapse id="collapse-6">
              <b-card>Impugnación de multas, impugnación de procedimientos emitidos por autoridades.</b-card>
            </b-collapse>
            <b-button v-b-toggle.collapse-7><p class="mb-4 bullets"><img src="../assets/arrow.svg" alt="flecha"> Derecho Familiar <span class="more">+</span><span class="less">-</span></p></b-button>
            <b-collapse id="collapse-7">
              <b-card>Divorcios, Pensiones Alimenticias, Custodia.</b-card>
            </b-collapse>
            <p class="mb-4 bullets"><img src="../assets/arrow.svg" alt="flecha"> Derecho Laboral</p>
          </b-col>
          <b-col lg="6">
            <p class="mb-4 bullets"><img src="../assets/arrow.svg" alt="flecha"> Derecho Ambiental</p>
            <p class="mb-4 bullets"><img src="../assets/arrow.svg" alt="flecha"> Registro de marcas</p>
            <p class="mb-4 bullets"><img src="../assets/arrow.svg" alt="flecha"> Registro de patentes</p>
            <p class="mb-4 bullets"><img src="../assets/arrow.svg" alt="flecha"> Creación de franquicias</p>
            <b-button v-b-toggle.collapse-13><p class="mb-4 bullets"><img src="../assets/arrow.svg" alt="flecha"> Derecho Societario <span class="more">+</span><span class="less">-</span></p></b-button>
            <b-collapse id="collapse-13">
              <b-card>Constitución de Sociedades, elaboración de Asambleas, estrategias societarias.</b-card>
            </b-collapse>
            <p class="mb-4 bullets"><img src="../assets/arrow.svg" alt="flecha"> Inversión extranjera</p>
            <b-button v-b-toggle.collapse-15><p class="mb-4 bullets"><img src="../assets/arrow.svg" alt="flecha"> Derechos de autor <span class="more">+</span><span class="less">-</span></p></b-button>
            <b-collapse id="collapse-15">
              <b-card>Registro de personajes, nombres artísticos, canciones, obras literarias, obras musicales.</b-card>
            </b-collapse>
            <p class="mb-4 bullets"><img src="../assets/arrow.svg" alt="flecha"> Prevención Lavado de Dinero</p>
          </b-col>
        </b-row>
      </b-container>
    </div>

    <b-container class="derecho-ambiental" style="position: relative;">
      <div id="derechos" style="position: absolute; top: -100px;"></div>
      <b-row>
        <b-col align-self="center" lg="6">
          <img class="img-fluid" src="../assets/derechoambiental.png" alt="derecho ambiental">
        </b-col>
        <b-col align-self="center" lg="6">
          <h3 class="mb-4">Derecho ambiental</h3>
          <p>Dentro de la legislación ambiental se define el ambiente como el conjunto de elementos naturales y artificiales o inducidos por el hombre que hacen posible la existencia y desarrollo de los seres humanos y demás organismos vivos que interactúan en un espacio y tiempo determinado.</p>
          <p>En 1869, la palabra ecología se utilizaba para designar una disciplina que estudiaba las relaciones entre el hombre y el ambiente.</p>
          <p>Por lo que podemos decir que de lo anterior el derecho ambiental antes conocido como ecológico, lo define Raúl Brañes, como un conjunto de normas jurí dicas que regulan las conductas humanas que pueden influir de una manera relevante en los procesos de interacción que tiene lugar entre los sistemas de organismos vivos y en sus sistemas de ambiente, mediante la generación de efectos de los que se espera una modificación significativa de las condiciones de existencia de dichos organismos.</p>
        </b-col>
      </b-row>
    </b-container>

    <div class="mision">
      <b-container>
        <b-row>
          <b-col align-self="center" lg="6">
            <h3 class="mb-4">Misión</h3>
            <p>Mediante la aplicación de derecho, las necesidades, problemas y circunstancias jurídicas de nuestros clientes, asesorándolos para lograr el mejor lítigo o negociación en cada una de sus situaciones jurídicas.</p>
            <h3 class="mb-4">Valores</h3>
            <p>HECTOR TERÁN & ABOGADOS es una firma que en todo momento salvaguarda los intereses de nuestros clientes, a fin de mejorar la transparencia, eficacia y honradez con la que actualmente se identifica, y que para tal efecto, dentro de nuestros valores se encuentra:</p>
            <b-row>
              <b-col>
                <ul>
                  <li>Ética</li>
                  <li>Profesionalismo</li>
                  <li>Responsabilidad</li>
                </ul>
              </b-col>
              <b-col>
                <ul>
                  <li>Honestidad</li>
                  <li>Lealtad</li>
                </ul>
              </b-col>
            </b-row>
          </b-col>
          <b-col class="text-right" align-self="center" lg="6">
            <img class="img-fluid" src="../assets/misionvalores.png" alt="mision y valores">
          </b-col>
        </b-row>  
      </b-container>
    </div>

    <div class="propiedad" style="position: relative;">
      <div id="gestion" style="position: absolute; top: -100px;"></div>
      <b-container>
        <b-row>
          <b-col align-self="center" class="mb-5" lg="6">
            <h3 class="mb-4">Derecho de propiedad intelectual e industrial</h3>
            <p>Una marca es un nombre o logotipo, isotipo, slogan o empaque que sirve para distinguir un servicio o producto de otros de su misma clase.</p>
            <p>Es muy común confundir el concepto de marca y logotipo y utilizar ambas palabras indistintamente para referimos a lo mismo. Aquí vamos a aclarar que es la Marca. La Marca es un término mucho más global que logotipo y recoge todos los aspectos que definen una empresa/individuo, aspectos tanto físicos como abstractos (su personalidad, su filosofía, su forma de comunicarse, su imagen gráfica, su logotipo, etc.)</p>
          </b-col>
          <b-col align-self="center" class="mb-5 text-right" lg="6">
            <img class="img-fluid ml-auto" src="../assets/uspto.png" alt="uspto">
          </b-col>
        </b-row>  
        <b-row>
          <b-col align-self="center" class="mb-5" lg="6">
            <img class="img-fluid" src="../assets/impi.png" alt="impi">
          </b-col>
          <b-col align-self="center" class="mb-5" lg="6">
            <p>Es muy común confundir el concepto de marca y logotipo y utilizar ambas palabras indistintamente para referimos a lo mismo. Aquí vamos a aclarar que es la Marca. La Marca es un término mucho más global que logotipo y recoge todos los aspectos que definen una empresa/individuo, aspectos tanto físicos como abstractos (su personalidad, su filosofía, su forma de comunicarse, su imagen gráfica, su logotipo, etc.)</p>
          </b-col>
        </b-row>  
      </b-container>
    </div>

    
    <div style="position: relative;">
      <div class="back"></div>
      <b-container class="contact">
        <div id="contacto" style="position: absolute; top: -100px;"></div>
        <b-row>
          <b-col lg="12">
            <img class="logo-footer" src="../assets/logo.svg" alt="logo">
          </b-col>
          <b-col class="mb-4" md="5">
            <h3 class="mb-2">Contáctanos</h3>
            <p>Completa el formulario o comunícate con nosotros a través de los siguientes medios.</p>
            <p class="error" v-if="messageSendBanner">{{ messageSendBanner }}</p>
            <b-form-input class="mb-2" id="input-1" v-model="name" placeholder="Nombre:" type="text"></b-form-input>
            <b-form-input class="mb-2" id="input-2" v-model="email" placeholder="Email:" type="text"></b-form-input>
            <b-form-input class="mb-2" id="input-2" v-model="phone" placeholder="Teléfono:" type="text"></b-form-input>
            <b-form-textarea class="mb-2" id="input-3" v-model="message" placeholder="Mensaje:" rows="6" max-rows="3"></b-form-textarea>
            <b-form-input autocomplete="off" tabindex="-1" id="input-1" class="pet-field" v-model="pet" placeholder="Alimento de mascota" type="text"></b-form-input>
            <b-button class="btn-enviar" v-on:click="sendMessage">Enviar <img src="../assets/arrow2.svg" alt="flecha"></b-button>
          </b-col>
          <b-col class="contact-info mb-4" offset-lg="1" lg="6" offset-md="0" md="7" style="position: relative;">
            <div class="small-square" style=""></div>
            <h3>Info</h3>
            <p class="contact-text"> <img src="../assets/ubi.svg"/> Blvd. Agua Caliente 4558<br>
                Piso 12 | Interior 1207<br>
                Col. Aviación | Tijuana, B.C.</p>
            <p class="contact-text"> <img src="../assets/telefono.svg"/> 664 568 6568</p>
            <p class="contact-text"> <img src="../assets/correo.svg"/><a href="mailto:hector.a@hectorteranabogado.com">hector.a@hectorteranabogado.com</a></p>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'Home',
  props: {
    msg: String
  },
  data() {
      return {
          name: '',
          email: '',
          phone: '',
          message: '',
          pet:'',
          messageSend: ''
      }
  },
  methods: {
    sendMessage: async function(){
      var responseData
      if(this.name != '' && this.email != '' && this.pet == ''){
        await axios.post('vendor/send-contact.php', {
          name: this.name,
          email: this.email,
          phone: this.phone,
          message: this.message
        })
        .then((response) => {
          responseData = response.data
        })
        .catch((error) => {
          /* eslint-disable no-console */
          console.log(error);
          /* eslint-enable no-console */
        });
        console.log(responseData);
        if(responseData==200 || responseData=='200') {
          this.name = ''
          this.email = ''
          this.message = ''
          this.phone = ''
          this.messageSend = 'Mensaje enviado'
        } else {
          this.messageSend = 'Error al enviar mensaje, intenta mas tarde.'
        }
      } else {
        this.messageSend = 'Ingresa la información necesaria en los campos.'
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul{
  padding-inline-start: 15px;
  font-size: 20px;
}
p{
  font-size: 20px;
}
h3{
  font-size: 40px;
}

/* NAVBAR */
.navbar{
  background: #fff;
  padding: 30px;
  box-shadow: 1px 1px 2px #00000020;
}
.navbar-light .navbar-nav .nav-link{
  color: #000;
  font-size: 20px;
  padding-left: 20px;
  padding-right: 20px;
}
.btn-contact{
  background: #69714C;
  color: #fff !important;
  border-radius: 30px;
  outline: none !important; 
}
.btn-contact>.nav-link{
  color: #fff !important;
}

/* BANNER */
.banner{
  margin-top: 150px;
  min-height: 100vh;
  background-image: url("../assets/bannerht.png"); /* The image used */
  background-color: #cccccc; /* Used if the image is unavailable */
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover; /* Resize the background image to cover the entire container */
  color: #fff;
}
.banner .row{
  min-height: 100vh;
}
.banner h1{
  font-size: 50px;
  line-height: 1.3;
}
.banner .btn{
  background: #93913F !important;
  border-radius: 30px;
  font-size: 20px;
  padding-top: 15px;
  padding-bottom: 15px;
  width: 175px;
  border: none !important;
  outline: none !important; 
}

/* NOSOTROS */
.nosotros{
  padding-top: 7%;
  padding-bottom: 7%;
}
.nosotros p{
  max-width: 770px;
  margin-left: auto;
  margin-right: auto;
}
.nosotros h4{
  font-weight: 400;
  font-size: 35px;
  margin-left: auto;
  margin-right: auto;
  max-width: 668px;
}
.nosotros .p1{
  margin-bottom: 150px;
}
.nosotros .p2{
  max-width: 940px !important;
}

/* SERVICIOS */
.servicios{
  background: #69714C;
  color: #fff;
  padding-top: 5%;
  padding-bottom: 5%;
}
.servicios .bullets{
  font-size: 30px;
  width: 100%;
  position: relative;
}
.servicios .card{
  border: none;
  font-size: 19px;
  background: transparent !important;
  margin-top: -30px;
}
.servicios .btn{
  width: 100%;
  border: none !important;
  text-align: left;
  background: transparent !important;
  padding-left: 0;
  outline: none !important; 
}
.servicios .btn .more,
.servicios .btn .less{
  font-size: 40px !important;
  position:absolute;
  right: -20px;
  top: -11px;
}

.servicios .btn.not-collapsed .more{
  display: none;
}
.servicios .btn.collapsed .less{
  display: none;
}

/* DERECHO AMBIENTAL */
.derecho-ambiental{
  padding-top: 5%;
  padding-bottom: 5%;
}

/* MISION Y VALORES */
.mision{
  background: #93913F;
  color: #fff;
  padding-top: 5%;
  padding-bottom: 5%;
}

/* PROPIEDAD INTELECTUAL */
.propiedad{
  background: #69714C;
  color: #fff;
  padding-top: 5%;
  padding-bottom: 5%;
}

/* CONTACTO */
.contact{
  padding-top: 5%;
  padding-bottom: 5%;
  position: relative;
}
.error{
  font-weight: 500;
  font-size: 14px !important;
  color: red;
}
.error-input{
  border-color: red !important;
}
.form-control{
  border: none;
  border-bottom: 1px solid #000;
  height: 40px;
  padding-left: 0;
  font-size: 20px;
  margin-bottom: 20px !important;
  border-radius: 0px;
}
.btn-enviar{
  border-radius: 0;
  background: #69714C;
  width: 100%;
  height: 60px;
  font-size: 20px;

}
.pet-field{
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    height: 0;
    width: 0;
    z-index: -1;
}
.contact-text{
  padding-left: 40px;
  position: relative;
}
.contact-text img{
  position: absolute;
  top: 7px;
  margin-left: -30px;
}
.contact-text a{
  color: #fff;
}
.contact-info{
  background: #93913F;
  color: #fff;
  /* height: fit-content; */
  padding: 7%;
  z-index: 10;
}
.small-square{
  background: #69714C;
  height: 80px;
  width: 80px;
  position: absolute;
  top: -30px;
  left: -30px;
}
.back{
  position: absolute;
  background: #69714C;
  height: 100%;
  width: 250px;
  right: 0;
}

@media (max-width: 768px) {
  /* CONTACT */
  .back{
    display: none;
  }
  .contact-info{
    margin-top: 100px;
  }
}
@media (max-width: 600px) {
  p{
    font-size: 20px;
  }
  h3{
    font-size: 40px;
  }
  .container{
    padding-left: 30px;
    padding-right: 30px;
  }
  /* NAVBAR */
  .navbar{
    padding: 20px;
  }
  .logo{
    width: 150px;
  }

  /* BANNER */
  .banner{
    margin-top: 100px;
    padding-top: 60px;
    padding-bottom: 50px;
  }
  .banner h1{
    font-size: 45px;
    line-height: 1.1;
  }

  /* NOSOTROS */
  .nosotros{
    padding-top: 70px;
    padding-bottom: 70px;
  }
  .nosotros p{
    max-width: 770px;
    margin-left: auto;
    margin-right: auto;
  }
  .nosotros h4{
    font-weight: 400;
    font-size: 30px;
    margin-left: auto;
    margin-right: auto;
    max-width: 668px;
  }
  .nosotros .p1{
    margin-bottom: 50px;
  }
  .nosotros .p2{
    max-width: 940px !important;
  }

  /* SERVICIOS */
  .servicios{
    padding-top: 70px;
    padding-bottom: 70px;
  }
  .servicios .bullets{
    font-size: 25px;
  }

  /* DERECHO AMBIENTAL */
  .derecho-ambiental{
    padding-top: 70px;
    padding-bottom: 70px;
  }

  /* MISION Y VALORES */
  .mision{
    padding-top: 70px;
    padding-bottom: 70px;
  }

  /* PROPIEDAD INTELECTUAL */
  .propiedad{
    padding-top: 70px;
    padding-bottom: 70px;
  }

  /* CONTACTO */
  .contact{
    padding-top: 70px;
    padding-bottom: 70px;
  }
  .form-control{
    border: none;
    border-bottom: 1px solid #000;
    height: 40px;
    padding-left: 0;
    font-size: 20px;
    margin-bottom: 20px !important;
    border-radius: 0px;
  }
  .btn-enviar{
    border-radius: 0;
    background: #69714C;
    width: 100%;
    height: 60px;
    font-size: 20px;

  }
  .pet-field{
      opacity: 0;
      position: absolute;
      top: 0;
      left: 0;
      height: 0;
      width: 0;
      z-index: -1;
  }
  .logo-footer{
    width: 170px;
  }
  .contact-text{
    padding-left: 40px;
    position: relative;
  }
  .contact-text img{
    position: absolute;
    top: 7px;
    margin-left: -30px;
  }
  .contact-text a{
    color: #fff;
    font-size: 18px !important;
  }
  .contact-info{
    background: #93913F;
    color: #fff;
    /* height: fit-content; */
    padding: 6%;
    z-index: 10;
  }
}
</style>
